import type { IVariable } from '@carboncopyco/types';
import type { PopoverProps } from '@carboncopyco/ui';
import { Popover } from '@carboncopyco/ui';
import type { VariablesSearchProps } from '../VariablesSearch';
import { VariablesSearch } from '../VariablesSearch';

export type VariablesSearchMenuProps<T extends IVariable> = Pick<
  PopoverProps,
  'open' | 'triggerElement' | 'container' | 'zIndex'
> &
  VariablesSearchProps<T>;

export const VariablesSearchMenu = <T extends IVariable>({
  open,
  title,
  triggerElement,
  variables,
  container,
  zIndex,
  onSelect,
}: VariablesSearchMenuProps<T>) => {
  return (
    <Popover
      open={open}
      triggerElement={triggerElement}
      arrow={false}
      container={container}
      zIndex={zIndex}
    >
      <VariablesSearch
        title={title}
        variables={variables}
        onSelect={onSelect}
      />
    </Popover>
  );
};
